<h2 class="order-confirmation-header-title">You’re all set</h2>
<div class="order-confirmation-header-desc">
  <p>{{ firstName }}, thanks for choosing {{ selectedCoverName }}.</p>
  <p>
    We’ve emailed you confirming your purchase, and will soon follow up with
    your {{ isInsurance ? 'policy' : 'plan' }} documents and details.
  </p>
</div>
